// import { Api } from 'yxt-biz-pc-base';
// const { ccApi } = Api;
import { ccApi } from 'yxt-biz-pc/packages/api';
/**
 * 创建举报
 * @param query
 * @return {*}
 */
export const createComplains = (data) => {
  return ccApi.post('complains', data);
};
